import {getPaymentProcessorURL, redirectByResponse, US_ACRONYMUN, US_PATTERNS, fcbhCredentials, removeFcbhCredentials} from "../payment";
import { getMeta, getValueWithoutSymbol, postWithCredentials, saveFormCampaignGIVE_FORM } from "../helpers";
import isEmpty from 'lodash/isEmpty';
import isNil from 'lodash/isNil';
import first from 'lodash/first';
import last from 'lodash/last';

export function beforeSubmit(formStruct, {errorBlockSelector}, minAmount = 2, requiredFields = undefined, fieldLabels = undefined) {
  hideErrors(errorBlockSelector);
  const errors = validateForm(formStruct, minAmount, requiredFields, fieldLabels);
  if (errors.length > 0) {
    showErrorWithMessage(errorBlockSelector, errors);
    return false;
  } 
 
  return true;
}

export async function processCCPayment(formStruct, {donateBtn, errorBlockSelector, responseParams, donateReCaptcha, formCampaign}, authData, type = "process") {
  hideErrors(errorBlockSelector);

  let cresponse = donateReCaptcha? grecaptcha.getResponse() : [];
  const initialDonateBtnText = donateBtn.value;

  try {
    const errors = validateForm(formStruct);
    if (errors.length > 0) {
      showErrorWithMessage(errorBlockSelector, errors);
      return;
    }
    
    donateBtn.value = "Processing...";
    donateBtn.disabled = true; 

    if (donateReCaptcha && cresponse.length == 0) { 
      return;
    }
    saveFormCampaignGIVE_FORM(formCampaign.localForm);

    await processAcceptJsPayment(formStruct, errorBlockSelector, responseParams, formCampaign, authData, type);

  } catch (err) {
    console.log(err);
    const response = { data: err.responseText };
    var failedStatuses = ['fail', 'decline', 'pending'];
    if(err?.status == 401 || err?.status == 403){
      showErrorWithMessage(errorBlockSelector,
        "You are not authorized or your token may have expired to perform this action. Please reload the page or try again later."
      );

    } else if(err?.status == 400 && err?.responseJSON.data.detailed_messages && !failedStatuses.includes(err?.responseJSON.status) ){
        showErrorWithMessage(errorBlockSelector ,err.responseJSON.data.detailed_messages);

    } else if (response.data?.includes("status")) {
      redirectByResponse(response, responseParams, formCampaign.localForm);
    } else if (err.message === "Failed Donation") {
      showErrorWithMessage(errorBlockSelector, "There was an error processing your payment, please try again later.");
    } else {
      showErrorWithMessage(errorBlockSelector, "An error occurred while sending the form, please try again later.");
    }
  } finally {
    donateBtn.value = initialDonateBtnText;
   // donateBtn.disabled = false;
  }
}

async function proccessCardPayment(formStruct, responseParams, errorBlockSelector, formCampaign, type) {
  console.log('call cc payment method');

  const formToSend = new FormData();

  for (const key in formStruct) {
    formToSend.append(key, formStruct[key]);
  }
  try {
    var apiKey = await fcbhCredentials();
    const response = await postWithCredentials(
      getPaymentProcessorURL(type),
      formToSend,
      apiKey
    );
    replaceCardInfo(formStruct);
    // We don't get the Location header due to cors, so we need to parse the response to check if its accepted or declined.
    redirectByResponse(response, responseParams, formCampaign.localForm);
  } catch(err) {
    console.error(err);
    const response = { data: err.responseText };
    var failedStatuses = ['fail', 'decline', 'pending'];

    if(err?.status == 400 && err?.responseJSON.data.detailed_messages && !failedStatuses.includes(err?.responseJSON.status) ){
        showErrorWithMessage(errorBlockSelector ,err.responseJSON.data.detailed_messages);

    } else if(err?.status == 401 || err?.status == 403){
      showErrorWithMessage(errorBlockSelector,
        "You are not authorized or your token may have expired to perform this action. Please reload the page or try again later."
      );

    } else if (response.data?.includes("status")) {
      redirectByResponse(response, responseParams, formCampaign.localForm);
    } else if (err.message === "Failed Donation") {
      showErrorWithMessage(errorBlockSelector, "There was an error processing your payment, please try again later.");
    } else {
      showErrorWithMessage(errorBlockSelector, "An error occurred while sending the form, please try again later.");
    }
  }

}

async function processAcceptJsPayment(formStruct,errorBlockSelector, responseParams, formCampaign, authData, type) {
  console.log('call acceptjs payment method');

  var data = {
    clientKey: null,
    apiLoginID: null,
  };
  data.clientKey = authData.clientKey;// getPaymentProcessorURL("clientKey");
  data.apiLoginID = authData.apiLoginID;// getPaymentProcessorURL("apiLoginID");*/
  
  var cardData = {};
  cardData.cardNumber = formStruct["card_num"].trim().replaceAll(" ", "");
  cardData.month = first(formStruct["card_expiration"].split("/"));
  cardData.year = last(formStruct["card_expiration"].split("/"));
  cardData.cardCode = formStruct["card_security_code"];
  cardData.zip = formStruct["address_zip"];
  cardData.fullName = `${formStruct["first_name"]} ${formStruct["last_name"]}`;
  var secureData = {};
  secureData.authData = data;
  secureData.cardData = cardData;

  let cardDataInfo = {};

  cardDataInfo.cardNumber = formStruct["card_num"].trim();
  cardDataInfo.expiration = formStruct["card_expiration"].trim();
  cardDataInfo.securityCode = formStruct["card_security_code"].trim();

  document.getElementById("Give-Status").style.display = "block";
  replaceCardInfo(formStruct);
  
  try { 
    Accept.dispatchData(secureData, (resp) => {
      responsesHandler(resp, formStruct, errorBlockSelector, responseParams, formCampaign, type, cardDataInfo, authData.apiKey);
    });
  } catch (err) {
    console.error(err);
    throw err;

  }

}

async function responsesHandler(resp, formStruct, errorBlockSelector, responseParams, formCampaign, type, cardDataInfo, apiKey) {
  var data = {};
  var responsew = {};
  data.detailed_messages = '';
  data.response_reason_text = '';

  if (resp.messages.resultCode === "Error") {
    responsew.status = 'Error';
      var i = 0;
      while (i < resp.messages.message.length) {
        data.response_reason_text += resp.messages.message[i].code;
        data.detailed_messages += resp.messages.message[i].text
          console.log(
            resp.messages.message[i].code + ": " +
            resp.messages.message[i].text
          );
          i = i + 1;
      }
      showErrorWithMessage(errorBlockSelector,  data.detailed_messages);

      document.getElementById("Give-Status").style.display = "none";
  } else {
    responsew.status = 'success';

    console.log("ok");
    
    await setTimeout(async () => {
      await paymentAcceptFormUpdate(resp.opaqueData, formStruct, errorBlockSelector, responseParams, formCampaign, type, cardDataInfo, apiKey);
    }, 5000);

  }
  responsew.data = data;
}

function replaceCardInfo(formStruct) {
  
  var cardNum = formStruct["card_num"].replace(/\s/g, "");
  document.getElementById("Give-Card-Number").value = cardNum.replace(/\d(?=\d{4})/g, "*");
  document.getElementById("Give-Month-Year").value = "";
  document.getElementById("Give-CVC").value = "";
}

function returnCardInfo(cardDataInfo) {
  
  document.getElementById("Give-Card-Number").value = cardDataInfo.cardNumber;
  document.getElementById("Give-Month-Year").value = cardDataInfo.expiration;
  document.getElementById("Give-CVC").value = cardDataInfo.securityCode;
  cleanCardInfo(cardDataInfo);

}

function cleanCardInfo(cardDataInfo) {

  cardDataInfo.cardNumber = "";
  cardDataInfo.expiration = "";
  cardDataInfo.securityCode = "";

}

export async function paymentAcceptFormUpdate(opaqueData, formStruct, errorBlockSelector, responseParams, formCampaign, type, cardDataInfo, apiKey) {
  formStruct["card_num"] = "";
  formStruct["card_expiration"] = "";
  formStruct["card_security_code"]="";

  const formToSend = new FormData();
  for (const key in formStruct) {
    formToSend.append(key, formStruct[key]);
  }
  formToSend.append('opaque_data_descriptor', opaqueData.dataDescriptor);
  formToSend.append('opaque_data_value', opaqueData.dataValue);

  try {
    const freshApiKey = await fcbhCredentials();
    const response = await postWithCredentials(
      getPaymentProcessorURL(type),
      formToSend,
      freshApiKey
    ); 

    document.getElementById("Give-Status").style.display = "none";
    cleanCardInfo(cardDataInfo);
    //removeFcbhCredentials();
    // We don't get the Location header due to cors, so we need to parse the response to check if its accepted or declined.
    redirectByResponse(response, responseParams, formCampaign.localForm);
  } catch(err) {
    console.error(err);
    document.getElementById("Give-Status").style.display = "none";
    const response = { data: err.responseText };
    var failedStatuses = ['fail', 'decline', 'pending'];

    if(err?.status == 400 && err?.responseJSON.data.detailed_messages && !failedStatuses.includes(err?.responseJSON.status) ){
        showErrorWithMessage(errorBlockSelector ,err.responseJSON.data.detailed_messages);

    } else if(err?.status == 401 || err?.status == 403){
      showErrorWithMessage(errorBlockSelector,
        "You are not authorized or your token may have expired to perform this action. Please reload the page or try again later."
      );

    } else if (response.data?.includes("status")) {
      redirectByResponse(response, responseParams, formCampaign.localForm);
    } else if (err.message === "Failed Donation") {
      showErrorWithMessage(errorBlockSelector, "There was an error processing your payment, please try again later.");
      returnCardInfo(cardDataInfo);
    } else {
      showErrorWithMessage(errorBlockSelector, "An error occurred while sending the form, please try again later.");
      returnCardInfo(cardDataInfo);
    }
  } finally {
    document.getElementById("Give-Status").style.display = "none";
      returnCardInfo(cardDataInfo);

  }

}

export function validateForm(formStruct, minAmount = 2, requiredFields = undefined, fieldLabels = undefined) {
    const requireds = requiredFields?? [
      "amount",
      "first_name",
      "last_name",
      "address_street",
      "address_city",
      "address_zip",
      "phone",
      "email",
      "card_num",
      "card_expiration",
      "card_security_code",
    ];
    const cleanNames = fieldLabels?? [
      "Amount",
      "First Name",
      "Last Name",
      "Address 1",
      "City",
      "Zip Code",
      "Phone Number",
      "Email",
      "Card Number",
      "Card Expiration",
      "CVC",
      "Company Name or Organization Name",
    ];

    const errors = [];
    for (const key in formStruct) {
      if (requireds.includes(key) && !formStruct[key]) {
        errors.push(`${cleanNames[requireds.indexOf(key)]} is required.`);
      }
      if (key === "card_num" && requireds.includes("card_num") && formStruct[key] && !isCCValid(formStruct[key])) {
        errors.push(`Please enter a valid credit card number.`);
      }
      if (key === "card_expiration" && requireds.includes("card_expiration") && !isExpirationValid(formStruct[key])) {
        errors.push(`Please enter a valid expiration date.`);
      }
      if (key === "first_name" || key === "last_name") {
        const regex = /^(['À-ÿa-zA-Z\/\s])*$/;
        if (!regex.test(formStruct[key])) {
          errors.push(`${cleanNames[requireds.indexOf(key)]} can only be letters.`);
        }
      }
      if (key === "email" && formStruct[key]) {
        const regex = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if (!regex.test(formStruct[key])) {
          errors.push(`${cleanNames[requireds.indexOf(key)]} is not valid.`);
        }
      }

      if ( key === "address_zip" && !isNil( formStruct[key] ) && !isEmpty( formStruct[key] ) 
        && formStruct.address_country === US_ACRONYMUN && !US_PATTERNS.zip_code.test( formStruct[key])){
        errors.push( `${cleanNames[requireds.indexOf(key)]} is not valid.` );
      }

      if ( key === "amount" && !isEmpty( getValueWithoutSymbol(formStruct[key], '$') )) { 
        let amount = getValueWithoutSymbol(formStruct[key], '$') ;
        amount = amount.replaceAll(",",'');
        if (isNaN(amount ) || amount <= 0 ) {
         errors.push( `Amount is required.` );
        }
      }
    }
    if(getMeta("donationType").toLowerCase() === "user's choice" && !formStruct['recurring_donation']) {
      errors.push(`Donation type is required.`);
    }
    if (getMeta("donationType")?.toLowerCase() === "monthly increase" && !formStruct['raise_consent']) {
      errors.push(`Donation update consent is required.`);
    }

    if (formStruct['customer_type_value'] && formStruct['company_name']?.length < 3) {
      errors.push(`${cleanNames[cleanNames.length - 1]} must have at least 3 characters.`);
    }
    
    if (minAmount && formStruct['usd_amount'] && formStruct['usd_amount'] < minAmount) {
        errors.push(`Please enter an amount greater than USD ${minAmount}.`);
    }

    return errors;
  }

  function isCCValid(value) {
    //replace all non-numberic values
    value = value.replace(/\D/g, "");

    if (value.length < 13 || value.length > 19) {
      return false;
    }

    //Pop off the last digit
    const lastDigit = value.slice(-1);

    //Get the value without the last digit
    value = value.slice(0, -1);

    //Reverse the string
    value = value.split("").reverse(); //.join("");

    let total = 0;
    for (let index = 0; index < value.length; ++index) {
      if (index % 2 == 0) {
        value[index] = value[index] * 2;
      }

      //Subtract 9 from each value over 9
      if (value[index] > 9) {
        value[index] = value[index] - 9;
      }

      total = Number(total) + Number(value[index]);
    }

    total = Number(total) * 9;

    //Value modulo 10 should equal the lastDigit variable if card is the correct format
    return total % 10 == lastDigit ? true : false;
  }

  function isExpirationValid(value) {
    value = value.replace(/\D/g, "");

    if (value.length != 4 && value.length != 6) {
      return false;
    }

    const expMonth = value.slice(0, 2);

    const expYear = value.slice(-2);

    const date = new Date();
    const currentMonth = Number(date.getMonth()) + 1; //array elements are used, so +1 to account for first element of zero
    const currentYear = date.getFullYear().toString().slice(-2); //just need the last two digits

    if (expYear == currentYear && expMonth < currentMonth) {
      return false;
    }

    if (expYear < currentYear) {
      return false;
    }

    if (expMonth < 1 || expMonth > 12) {
      return false;
    }

    return true;
  }

  export function showErrorWithMessage(errorBlockSelector, messages) {
    let message;
    if (Array.isArray(messages)) {
      message = `Please address these errors before proceeding:<br/>${messages.join("<br/>")}`;
    } else {
      message = messages;
    }
    var errorBlock = typeof errorBlockSelector === "string" ? document.querySelectorAll(errorBlockSelector)[0] : errorBlockSelector;
    if (errorBlock) {
      const msgContainer = errorBlock.querySelector("div") || errorBlock;
      msgContainer.innerHTML = message;
      errorBlock.style.display = "block";
      window.scrollTo(0, errorBlock.offsetTop - 150);
    }
  }

  export function hideErrors(errorBlockSelector) {
    var errorBlock = typeof errorBlockSelector === "string" ? document.querySelectorAll(errorBlockSelector)[0] : errorBlockSelector;
    if (errorBlock) {
      errorBlock.style.display = "none";
    }
  }